import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

import { AuthContext } from "../../context/authContext";
import {
  isPathModuleAllowed,
  hasModuleAccess,
  hasAnyModuleAccess,
  isAdminUser,
} from "../../constants/appModules";
import { userNavItems } from "../MainNavs/navItems";
import Error from "../../pages/public/Error";

const PUBLIC_LAYOUT_PREFIXES = ["/login", "/home", "/contact", "/guest", "/dev"];

const isPublicLayoutPath = (pathname) =>
  pathname === "/" ||
  PUBLIC_LAYOUT_PREFIXES.some((prefix) => pathname.startsWith(prefix));

const ModuleRouteGuard = ({ children }) => {
  const { pathname } = useLocation();
  const { user, allowedModules, modulesReady, authBootstrapComplete } =
    useContext(AuthContext);

  const isLoggedIn = Boolean(user?.id || user?.email);

  if (!authBootstrapComplete || (isLoggedIn && !modulesReady)) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "40vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!isLoggedIn || isPublicLayoutPath(pathname)) {
    return children;
  }

  if (isAdminUser(user) || isPathModuleAllowed(pathname, allowedModules, user)) {
    return children;
  }

  const canAccessNavItem = (item) => {
    if (item.modulesAny?.length) {
      return hasAnyModuleAccess(allowedModules, item.modulesAny);
    }
    if (item.module) {
      return hasModuleAccess(allowedModules, item.module);
    }
    return true;
  };

  const fallbackNav = userNavItems.find(
    (item) =>
      item.type === "link" &&
      canAccessNavItem(item) &&
      (!item.adminOnly || isAdminUser(user)),
  );

  if (fallbackNav?.link && fallbackNav.link !== pathname) {
    return <Navigate to={fallbackNav.link} replace />;
  }

  return <Error error="ModuleNotLicensed" />;
};

export default ModuleRouteGuard;
